import { Component } from '@angular/core';

import { combineLatest, map, Observable } from 'rxjs';

import { ChaptersClient } from 'content-manager/src/app/core/open-api/content-manager-api-client';
import { ProjectStateService } from 'content-manager/src/app/projects/project/project-state.service';

interface IProjectTopicsViewModel {
    isReadonly: boolean;
    hasChapters: boolean;
}

@Component({
    templateUrl: './project-topics.component.html',
    standalone: false
})
export class ProjectTopicsComponent {

    public readonly viewModel$: Observable<IProjectTopicsViewModel>;

    constructor(
        projectStateService: ProjectStateService,
        chaptersClient: ChaptersClient) {

        this.viewModel$ = combineLatest([
            projectStateService.model$,
            projectStateService.switchMap(project => chaptersClient.hasChapters(project.id))])
            .pipe(map(([project, hasChapters]) => ({
                isReadonly: project.isReadonly,
                hasChapters
            })));
    }
}
